import { AppRouteUi } from "../../config/appRoute";

/* eslint-disable jsx-a11y/anchor-is-valid */
export const Footer = (props: any) => {
  return (
    <footer className="footer visitBooker-footer footer-visibility">
      <div className="row align-items-center justify-content-between ">
        <div className="col-md-4 col-12">
          <a
            href={AppRouteUi.PrivacyPolicy.Root()}
            className="btn btn-link text-capitalize footer-btn-link"
          >
            privacy policy
          </a>
        </div>
        <div className="col-md-6 col-12 mt-md-0 mr-5 d-flex">
          <p className="mb-0 ms-md-auto ms-0">
            webEVV &copy;{new Date().getFullYear()}. All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};
